import {ActionTypes} from '../constants/ActionTypes';
import {Map, fromJS} from 'immutable';
import {generate} from 'randomstring';
import moment from 'moment';
import 'moment/locale/vi';

moment.locale('vi-VN');

const initialState = [];
const initialMap = Map({})
const initialPushIssues = '';

const issues = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.GET_ISSUES:
            return getIssues(state, action);
        case ActionTypes.SAVE_EVENT:
            return saveEvent(state, action);
        case ActionTypes.SAVE_NEW_EVENT:
            return saveNewEvent(state, action);
    }

    return state;
};

const trackersMap = (state = initialMap, action) => {
    switch (action.type) {
        case ActionTypes.GET_TRACKERS_MAP:
            return getTrackersMap(state, action);
    }
    return state;
};

const issuesMap = (state = initialMap, action) => {
    switch (action.type) {
        case ActionTypes.GET_ISSUES_MAP:
            return getIssuesMap(state, action);
        case ActionTypes.SAVE_EVENT_MAP:
            return saveEventMap(state, action);
        case ActionTypes.SAVE_NEW_EVENT_MAP:
            return saveNewEventMap(state, action);
        case ActionTypes.REMOVE_ISSUE_TO_MAP:
            return removeIssueToMap(state, action);
    }
    return state;
}

const pushIssues = (state = initialPushIssues, action) => {
    switch (action.type) {
        case ActionTypes.SET_PUSH_ISSUES:
            return setPushIssues(state, action);
    }
    return state;
}

function setPushIssues(state, action) {
    let randomstring = '';
    for (var index = 0; index < 10; index++) {
        randomstring = generate();
        if (state != randomstring) {
            return randomstring;
        }
    }
    return randomstring;
}

function removeIssueToMap(state, action) {
    const {issue} = action;
    state = state.delete(issue.id.toString());

    return state;
}

function saveEventMap(state, action) {
    const {issue} = action;
    if (issue.id && issue.id > 0) {

        if (typeof issue.startDate === 'string' && !issue.start) {
            issue.start = new Date(issue.startDate);
        }

        issue.allDay = false;
        if (issue.startTime) {
            let arrTime = issue.startTime.split(":");
            issue.start.setHours(parseInt(arrTime[0]));
            issue.start.setMinutes(parseInt(arrTime[1]));
        }

        if (!issue.dueDate) {
            if (issue.end) {
                issue.dueDate = issue.end;
            } else {
                issue.end = issue.start;
            }
        } else {
            if (typeof issue.dueDate === 'string' && !issue.end) {
                issue.end = new Date(issue.dueDate);
            }
        }

        if (issue.dueTime) {
            let arrTime = issue.dueTime.split(":");
            if (issue.end && arrTime.length >= 2) {
                issue.end.setHours(parseInt(arrTime[0]));
                issue.end.setMinutes(parseInt(arrTime[1]));
            }
        }

        state = state.set(issue.id.toString(), fromJS(issue));
    }

    return state;
}

function saveNewEventMap(state, action) {
    const {issue} = action;

    if (typeof issue.startDate === 'string' && !issue.start) {
        issue.start = new Date(issue.startDate);
    }

    issue.allDay = false;
    if (issue.startTime) {
        let arrTime = issue.startTime.split(":");
        issue.start.setHours(parseInt(arrTime[0]));
        issue.start.setMinutes(parseInt(arrTime[1]));
    }

    if (!issue.dueDate) {
        if (issue.end) {
            issue.dueDate = issue.end;
        } else {
            issue.end = issue.start;
        }
    } else {
        if (typeof issue.dueDate === 'string' && !issue.end) {
            issue.end = new Date(issue.dueDate);
        }
    }

    if (issue.dueTime) {
        let arrTime = issue.dueTime.split(":");
        if (issue.end && arrTime.length >= 2) {
            issue.end.setHours(parseInt(arrTime[0]));
            issue.end.setMinutes(parseInt(arrTime[1]));
        }
    }

    state = state.set(issue.id.toString(), fromJS(issue));

    return state;
}

function saveEvent(state, action) {
    const {events} = action;
    let issueIschange = {};
    if (events.id) {
        for (var index = 0; index < state.length; index++) {
            var eventState = state[index];
            if (eventState.id === events.id) {
                for (var prop in events) {
                    eventState[prop] = events[prop];
                }
                state[index] = eventState;
                break;
            }
        }
        return [...state];
    }
    return [...state, events];
}

function saveNewEvent(state, action) {
    const {events} = action;
    if (events.id) {
        return [...state, events];
    }
    return state;
}

function getIssues(state, action) {
    const {issues} = action;
    return issues;
}

function getIssuesMap(state, action) {
    const {issuesMap} = action;

    let curState = Map({});

    if (issuesMap && issuesMap.length > 0) {
        issuesMap.map((issue) => {
            if (typeof issue.startDate === 'string' && !issue.start) {
                issue.start = new Date(issue.startDate);
            }

            issue.allDay = false;
            if (issue.startTime) {
                let arrTime = issue.startTime.split(":");
                issue.start.setHours(parseInt(arrTime[0]));
                issue.start.setMinutes(parseInt(arrTime[1]));
            }

            if (!issue.dueDate) {
                if (issue.end) {
                    issue.dueDate = issue.end;
                } else {
                    issue.end = issue.start;
                }
            } else {
                if (typeof issue.dueDate === 'string' && !issue.end) {
                    issue.end = new Date(issue.dueDate);
                }
            }

            if (issue.dueTime) {
                let arrTime = issue.dueTime.split(":");
                if (issue.end && arrTime.length >= 2) {
                    issue.end.setHours(parseInt(arrTime[0]));
                    issue.end.setMinutes(parseInt(arrTime[1]));
                }
            }

            curState = curState.set(issue.id.toString(), fromJS(issue));
        });
    }

    return curState;
}

function getTrackersMap(state, action) {
    const {trackers} = action;
    state = Map({});
    trackers.map((tracker) => {
        state = state.set(tracker.trackerID.toString(), tracker.name);
    });
    return state;
}

function selectUserMap(state, action) {
    const {usersMap} = action;
    state = Map({});
    usersMap.map((user) => {
        state = state.set(user.id.toString(), fromJS(user));
    });
    return state;
}

export {issues, issuesMap, trackersMap, pushIssues};


// WEBPACK FOOTER //
// ./src/reducers/events.js